import React from 'react';
import PropTypes from 'prop-types';
import Stepper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Stepper';
import Step from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Step';
import StepLabel from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/StepLabel';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';

// This stepper feels like it is likely a good candidate for FD. The UI is still a bit in flux, but once we have
// decided that we like the UI as-is it will probably be a good time to move it over to FD
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'transparent', // The MUI progress stepper applies its own white background color which we don't want
    '& .MuiStepLabel-active': {
      color: theme.palette.facet.oceana800,
      fontWeight: 700,
    },
    '& .MuiStepLabel-completed': {
      color: theme.palette.facet.oceana800,
      fontWeight: 700,
    },
    '&.Mui-disabled .MuiStepLabel-label': {
      color: theme.palette.text.disabled,
      fontWeight: 700,
    },
    '& .MuiStepConnector-active .MuiStepConnector-line': {
      borderColor: theme.palette.facet.oceana500,
    },
    '& .MuiStepConnector-completed .MuiStepConnector-line': {
      borderColor: theme.palette.facet.oceana500,
    },
  },
  fullWidth: {
    width: '100%',
  },
  sm: {
    width: '300px',
  },
  md: {
    width: '400px',
  },
  lg: {
    width: '600px',
  },
}));

export const ProgressStepper = ({
  steps, activeStep, fullWidth, size,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <Stepper
      className={classNames(classes.root, {
        [classes.fullWidth]: fullWidth,
        [classes.sm]: size === 'sm',
        [classes.md]: size === 'md',
        [classes.lg]: size === 'lg',
      })}
      activeStep={activeStep}
      alternativeLabel
    >
      {steps.map((step) => (
        <Step key={step.id}>
          <StepLabel className={classes.root}>{step.label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

ProgressStepper.defaultProps = {
  fullWidth: false,
  size: undefined,
};

ProgressStepper.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  fullWidth: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.objectOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired).isRequired,
  activeStep: PropTypes.number.isRequired,
};
